var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component, Fragment as ReactFragment } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { number, string, eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction, isMobile } from '@philips-internal/oswald-ui-utils';
import Avatar from '@philips-internal/oswald-ui-components/lib/components/avatar/avatar';
import { Card, Field, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import './user-card.css';
import UserCardAPI from './user-card-api';
let UserCard = class UserCard extends Component {
    constructor() {
        super(...arguments);
        this.onClickCard = () => {
            const { onClickCard, nrSequence, nmPhysicalPerson, dsLogin, situation, dtAtivacao } = this.props;
            const type = this.getAccess();
            const situationDesc = this.getSituation();
            if (isFunction(onClickCard)) {
                onClickCard(new ClickEvent({
                    value: {
                        nrSequence, nmPhysicalPerson, dsLogin, situationDesc, type, situation, dtAtivacao
                    }
                }));
            }
        };
    }
    getAccess() {
        const { typeAccess } = this.props;
        switch (typeAccess) {
            case 2:
                return MessageService.translate('results.insurance');
            case 3:
                return MessageService.translate('result.category');
            default:
                return MessageService.translate('result.prior.location');
        }
    }
    getSituation() {
        const { situation } = this.props;
        switch (situation) {
            case 'I':
                return MessageService.translate('results.profile-i');
            default:
                return MessageService.translate('results.active');
        }
    }
    renderContent() {
        const { nmPhysicalPerson, fotoBase64, dsLogin, situation } = this.props;
        if (isMobile()) {
            return (React.createElement(ReactFragment, null,
                React.createElement(Card, { width: 12, className: 'c-patient-card', onClick: () => this.onClickCard(), selectionType: SelectionType.SINGLE, uuid: "352fcf8f-0b4c-42a5-8aa7-be51658975e7" },
                    React.createElement("div", { className: 'c-patient-card__indicator' },
                        React.createElement("div", { className: `c-patient-card__indicator-color ${situation === 'A' ? 'c-patient-card__indicator--active' : 'c-patient-card__indicator--inactive'}` })),
                    React.createElement(Avatar, { image: fotoBase64 }),
                    React.createElement(Field, { uuid: '46e197c4-7904-4be5-9656-33a6a2a2eeb0', entry: '', className: "c-title-value", label: "" },
                        React.createElement("div", null,
                            React.createElement(Text, { className: "c-label", value: nmPhysicalPerson })),
                        React.createElement("div", null,
                            React.createElement(Text, { value: dsLogin })),
                        React.createElement("div", null,
                            React.createElement(Text, { value: this.getAccess() })),
                        React.createElement("div", null,
                            React.createElement(Text, { className: "space-bottom", value: this.getSituation() }))))));
        }
        return (React.createElement(ReactFragment, null,
            React.createElement(Card, { width: 12, className: 'c-patient-card', onClick: () => this.onClickCard(), selectionType: SelectionType.SINGLE, uuid: "352fcf8f-0b4c-42a5-8aa7-be51658975e7" },
                React.createElement("div", { className: 'c-patient-card__indicator' },
                    React.createElement("div", { className: `c-patient-card__indicator-color ${situation === 'A' ? 'c-patient-card__indicator--active' : 'c-patient-card__indicator--inactive'}` })),
                React.createElement(Avatar, { image: fotoBase64 }),
                React.createElement("div", { className: 'user-card-field' },
                    React.createElement(Text, { bold: true, className: "c-title-value", value: MessageService.translate('results.user') }),
                    React.createElement(Text, { value: nmPhysicalPerson, className: "c-title-value" })),
                React.createElement("div", { className: 'user-card-field' },
                    React.createElement(Text, { bold: true, className: "c-title-value", value: MessageService.translate('results.user.login') }),
                    React.createElement(Text, { className: "c-title-value", value: dsLogin })),
                React.createElement("div", { className: 'user-card-field' },
                    React.createElement(Text, { bold: true, className: "c-title-value", value: MessageService.translate('results.type.access') }),
                    React.createElement(Text, { value: this.getAccess(), className: "c-title-value" })),
                React.createElement("div", { className: 'user-card-field' },
                    React.createElement(Text, { bold: true, className: "c-title-value", value: MessageService.translate('label.situations') }),
                    React.createElement(Text, { value: this.getSituation(), className: "c-title-value" })))));
    }
    render() {
        return (React.createElement(ReactFragment, null, this.renderContent()));
    }
};
UserCard.propTypes = {
    nrSequence: number,
    dsLogin: string,
    fotoBase64: string,
    nmPhysicalPerson: string,
    onClickCard: eventListener,
    situation: string,
    typeAccess: number,
    dtAtivacao: string
};
UserCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: UserCardAPI })
], UserCard);
export default UserCard;
//# sourceMappingURL=user-card.js.map